import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";

import Header from './components/Header';
import IconTray from './components/IconTray';
import Sidebar from './components/Sidebar';
import MainContent from './components/MainContent';
import ContactContent from './components/ContactContent';
import Oww2AccountDeletionContent from './components/Oww2AccountDeletionContent';
import AshiatochoContent from './components/AshiatochoContent';
import AboutContent from './components/AboutContent';
import Footer from './components/Footer';
import './App.css';
import StoryOverlay from './components/StoryOverlay'; // 『薄荷』式オーバーレイ

function App() {
  const location = useLocation();
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [iconTrayVisible, setIconTrayVisible] = useState(false);

  const toggleSidebar = (visible) => setSidebarVisible(visible);
  const toggleIconTray = (visible) => setIconTrayVisible(visible);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) setIconTrayVisible(false);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const [storyOpen, setStoryOpen] = useState(false);
  useEffect(() => setStoryOpen(false), []);

  useEffect(() => {
    const fallback = document.getElementById('oauth-privacy-fallback');
    if (!fallback) return;

    const normalizedPath = location.pathname.replace(/\/+$/, '') || '/';
    const shouldShowFallback =
      normalizedPath === '/ashiatocho' ||
      normalizedPath === '/ashiatocho/index.html';

    fallback.hidden = !shouldShowFallback;
  }, [location.pathname]);

  return (
    <div className="App">
      <Header toggleIconTray={toggleIconTray} iconTrayVisible={iconTrayVisible} />

      <Sidebar sidebarVisible={sidebarVisible} toggleSidebar={toggleSidebar} />

      <IconTray
        toggleSidebar={toggleSidebar}
        className={sidebarVisible ? 'hidden' : 'visible'}
        visible={iconTrayVisible}
      />

      <main>
        <div className="container">
          <Routes>
            {/* 最新記事 */}
            <Route path="/" element={<MainContent slug="latest" />} />

            {/* アーカイブ記事 */}
            <Route path="/archive/:slug" element={<MainContent />} />

            <Route path="/contact" element={<ContactContent />} />
            <Route path="/ashiatocho" element={<AshiatochoContent />} />
            <Route path="/oww2/account-deletion" element={<Oww2AccountDeletionContent />} />
            <Route path="/about" element={<AboutContent />} />
          </Routes>
        </div>
      </main>

      <Footer />

      <StoryOverlay open={storyOpen} onClose={() => setStoryOpen(false)} />
    </div>
  );
}

export default App;
